const createSearchItem = ({
  id,
  name,
  name_tr,
  url,
  searchTerms = [],
  searchTerms_tr = [],
  category = 'Ticket Restaurant',
  category_tr = category,
}) => ({
  id,
  name,
  name_tr,
  category,
  category_tr,
  searchText: [name, ...searchTerms, category].join('|'),
  searchText_tr: [name_tr, ...searchTerms_tr, category_tr].join('|'),
  url,
});

const searchItems = [
  {
    id: 'ticket-car-1',
    name: 'Add Vehicle',
    name_tr: 'Araç Ekleme',
    url: '/ticket-car/add-car',
    category: 'Ticket Car',
    category_tr: 'Ticket Car',
  },
  {
    id: 'ticket-car-2',
    name: 'Vehicle Management',
    name_tr: 'Araç Yönetimi',
    url: '/ticket-car/vehicle-management',
    category: 'Ticket Car',
    category_tr: 'Ticket Car',
  },
  {
    id: 'ticket-restaurant-1',
    name: 'Balance Upload',
    name_tr: 'Bakiye Yükleme',
    searchTerms: ['Order'],
    searchTerms_tr: ['Sipariş'],
    url: '/ticket-restaurant/balance-upload',
  },
  {
    id: 'ticket-restaurant-2',
    name: 'New Card Order',
    name_tr: 'Yeni Kart Siparişi',
    url: '/ticket-restaurant/card-orders',
  },
  {
    id: 'ticket-restaurant-3',
    name: 'My Orders',
    name_tr: 'Siparişlerim',
    url: '/ticket-restaurant/my-orders',
  },
  {
    id: 'ticket-restaurant-4',
    name: 'My Drafts',
    name_tr: 'Taslaklarım',
    url: '/ticket-restaurant/draft-order',
  },
  {
    id: 'ticket-restaurant-5',
    name: 'Auto Upload Instructions',
    name_tr: 'Otomatik Yükleme Talimatı',
    url: '/ticket-restaurant/auto-upload-instructions',
  },
  {
    id: 'ticket-restaurant-6',
    name: 'Card Transactions',
    name_tr: 'Kart İşlemleri',
    searchTerms: ['Cancel', 'Block', 'Blocking'],
    searchTerms_tr: ['İptal', 'Bloke', 'Blokaj'],
    url: '/ticket-restaurant/manage-my-cards',
  },
  {
    id: 'ticket-restaurant-7',
    name: 'Balance Transfer',
    name_tr: 'Bakiye Transferi',
    searchTerms: ['Limit'],
    searchTerms_tr: ['Limit', 'limit'],
    url: '/ticket-restaurant/manage-my-cards/balance-transfer',
  },
  {
    id: 'ticket-restaurant-8',
    name: 'BA/BS',
    name_tr: 'BA/BS',
    searchTerms: ['Invoice'],
    searchTerms_tr: ['Fatura'],
    url: '/ticket-restaurant/ba-bs',
  },
  {
    id: 'ticket-restaurant-9',
    name: 'Invoice Tracking',
    name_tr: 'Fatura Takibi',
    searchTerms: ['invoice address change'],
    searchTerms_tr: ['fatura adresi değişikliliği'],
    url: '/ticket-restaurant/my-invoices',
  },
  {
    id: 'ticket-restaurant-10',
    name: 'Balance Report',
    name_tr: 'Bakiye Raporu',
    searchTerms: ['Limit'],
    searchTerms_tr: ['limit'],
    url: '/ticket-restaurant/balance-report',
  },
  {
    id: 'company-information-1',
    name: 'General Company Information',
    name_tr: 'Genel Şirket Bilgileri',
    searchTerms: [
      'title change',
      'invoice address change',
      'Address',
      'Invoice Address',
    ],
    searchTerms_tr: [
      'ünvan değişikliliği',
      'fatura adresi değişikliliği',
      'Adres',
      'Fatura Adresi',
    ],
    url: '/company-information/general-company-information',
  },
  {
    id: 'company-information-2',
    name: 'Delivery Addresses',
    name_tr: 'Teslimat adresleri',
    searchTerms: ['Delivery Address', 'Address Change'],
    searchTerms_tr: ['Teslimat Adresi', 'Adres Değişikliği'],
    url: '/company-information/delivery-adresses',
  },
  {
    id: 'company-information-3',
    name: 'User Management',
    name_tr: 'Kullanıcı Yönetimi',
    url: '/company-information/management-user',
  },
].map(createSearchItem);

export default searchItems;